import { IconButton, Typography } from "@material-ui/core"
import { useRouter } from "next/router"
import styled from "styled-components"
import BackIcon from "../../components/Icons/BackIcon"

const StyledLink = styled.div<{ $padding: string; $mobilePadding: string }>`
  display: flex;
  cursor: pointer;

  p {
    margin-right: 8px;
  }

  :hover {
    text-decoration: underline;
  }

  ${(p) => p?.$padding && `padding: ${p.$padding};`}

  ${(p) => p.theme.breakpoints.down("sm")} {
    ${(p) => p?.$mobilePadding && `padding: ${p?.$mobilePadding};`}
  }
`

const StyledIconBtn = styled(IconButton)`
  padding: 1px;
  position: relative;
  bottom: 2px;
`

const StyledText = styled(Typography)<{ $hideTextOnMobile?: boolean }>`
  ${(p) => p.theme.breakpoints.down("sm")} {
    ${(p) => p?.$hideTextOnMobile && "display: none;"}
  }
`

type BackButtonProps = {
  linkText?: string
  prevPath?: string
  padding?: string
  mobilePadding?: string
  beforeNavigation?: () => void
  preventNavigation?: boolean
  className?: string
  hideTextOnMobile?: boolean
  afterNavigation?: () => void
}

const BackButton = ({
  prevPath,
  linkText,
  padding,
  mobilePadding,
  beforeNavigation,
  preventNavigation,
  className,
  hideTextOnMobile,
  afterNavigation,
}: BackButtonProps) => {
  const router = useRouter()

  return (
    <StyledLink
      className={className}
      $padding={padding}
      $mobilePadding={mobilePadding}
      onClick={() => {
        if (beforeNavigation) {
          beforeNavigation()
        }
        if (preventNavigation) return
        if (prevPath) {
          router.push(prevPath)
        } else {
          router.back()
        }
        afterNavigation && afterNavigation()
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          if (beforeNavigation) {
            beforeNavigation()
          }
          if (preventNavigation) return
          if (prevPath) {
            router.push(prevPath)
          } else {
            router.back()
          }
          afterNavigation && afterNavigation()
        }
      }}
    >
      <StyledIconBtn
        aria-label="חזרה לעמוד קודם"
        role="presentation"
        tabIndex={-1}
      >
        <BackIcon />
      </StyledIconBtn>
      <StyledText variant="body1" $hideTextOnMobile={hideTextOnMobile}>
        {linkText}
      </StyledText>
    </StyledLink>
  )
}

export default BackButton
